export default __webpack_public_path__ + "static/media/flitbase-alt-center.c4225e73.svg";